<template>
  <div class="rad-page">
    <div id="recaptcha_container"></div>

    <AboutHeader />

    <div class="rad-body">
      <div class="doc-contents">
        <div class="content-holder">
          <div v-if="actuallyDeleting === true">
            <h1>ARE YOU SURE YOU WANT TO DELETE YOUR ACCOUNT?</h1>
            <span class="description">If you opt to delete your account this will be done immediately and is irreversible.</span>
          </div>
          <div v-else>
            <h1>REQUEST ACCOUNT DELETION</h1>
            <span class="description">Enter your email address and we will send you an email to confirm that you want your data and account deleted. This action is immediate and irreversible, please ensure you want to delete your account before proceeding.</span>
          </div>
          
          <div class="delete-form" v-if="actuallyDeleting === true && deleted === false">
            <span>Deleting: {{emailDeleting}}</span>
            <button @click="deleteAccount">YES, DELETE MY ACCOUNT</button>
          </div>
          <div class="delete-success" v-else-if="deleted === true">
            <div class="header">
              <img src="../assets/like.png" class="web-image">
              <h1>We've deleted your account</h1>
            </div>
            <p class="margin-bottom">{{emailAddress}}</p>
            <p>We hope to see you back one day!</p>
          </div>
          <div class="delete-form" v-else-if="requested === false">
            <label>EMAIL ADDRESS</label>
            <div class="input-holder">
              <input 
                v-model="emailAddress"
                autocomplete="off"
                class="error-msg-input"
                type="email"
                placeholder="Enter your email address"
                spellcheck="false" />
              <p v-if="erroMsg !== ''" class="error-msg">{{ erroMsg }}</p>
            </div>
            <button @click="deleteAccountRequest">REQUEST ACCOUNT DELETION</button>
          </div>
          <div class="delete-success" v-else-if="requested === true">
            <div class="header">
              <img src="../assets/like.png" class="web-image">
              <h1>We've sent you an email</h1>
            </div>
            <p class="margin-bottom">{{emailAddress}}</p>
            <p>Please check your inbox and continue with the next steps.</p>
          </div>
        </div>
      </div>
    </div>
  
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer.vue';
import AboutHeader from '@/components/header/AboutHeader.vue';
import { requestAccountDelete, deleteActualAccount } from '@/api/requests';

export default {
  name: 'RequestAccountDelete',

  data() {
    return {
      emailAddress: '',
      erroMsg: '',
      requested: false,
      emailDeleting: '',
      actuallyDeleting: false,
      deleted: false,
      token: '',
    };
  },

  components: {
    Footer,
    AboutHeader,
  },

  mounted() {
    // Setup recatcha
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/enterprise.js?render=6LchxuApAAAAAKtMWOJ5qln4x4-0VhutEH6V3rC_"
    );
    recaptchaScript.setAttribute("async", "true");
    recaptchaScript.setAttribute("defer", "true");
    document.head.appendChild(recaptchaScript);

    // Check for token to render page
    this.checkForToken();
  },

  methods: {
    deleteAccountRequest() {
      if (this.emailAddress !== '') {
        grecaptcha.enterprise.ready(async () => {
          const token = await grecaptcha.enterprise.execute('6LchxuApAAAAAKtMWOJ5qln4x4-0VhutEH6V3rC_', {action: 'LOGIN'});

          const userData = { 
            email: this.emailAddress,
            token: token
          };

          requestAccountDelete(userData).then(_ => {
            this.requested = true;
          }).catch(() => {
            // TODO errors
            this.erroMsg = "Something went wrong! If this keeps happening please contact support at info@wotive.com.";
          });
        });
      } else {
        this.erroMsg = "Please enter an email address and try again.";
      }
    },

    deleteAccount() {
      if (this.token !== '') {
        const data = { token: this.token };

        deleteActualAccount(data).then(_ => {
          this.deleted = true;
        }).catch(() => {
          // TODO errors
          this.erroMsg = "Something went wrong! If this keeps happening please contact support at info@wotive.com.";
        });
      } else {
        this.erroMsg = "Token is invalid. Please try the link in the email again.";
      }
    },

    checkForToken() {
      const token = this.$route.query.token;
      const emailToDelete = this.$route.query.email;

      if (token && emailToDelete) {
        this.actuallyDeleting = true;
        this.token = token;
        this.emailDeleting = emailToDelete;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/css/variables";
.rad-page {
  background: #F4F7FA;
  .rad-body {
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 1022px;
    margin: auto;

    h1 {
      text-transform: uppercase;
      text-align: center;
    }

    span {
      color: $sec2;
    }

    .doc-contents {
      display: flex;
      padding-top: $spacing-large;
      padding-bottom: 300px;
    }

    h1 {
      margin: 0;
      font-size: 48px;
      color: $sec0;
    }

    p {
      font-size: 16px;
      color: $sec2;
      margin-top: 0;
    }
  }
}

.delete-form {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.error-msg {
  color: $red1 !important;
}

.delete-success {
  .header {
    display: flex;
    justify-content: center;
  
    h1 {
      margin: 0;
      padding: 0;
      text-align: center;
      color: $blue;
      font-weight: 500;
      font-size: 24px;
      margin-top: $spacing-small;
      margin-left: $spacing-small;
    }
  }

  p {
    margin-top: $spacing-small;
    margin-bottom: 0;
    color: $blue !important;
    text-align: center;
    font-size: 14px;
  }
}

.content-holder {
  max-width: 800px;
  margin: auto;
  align-items: center;
  display: flex;
  flex-direction: column;

  .input-holder {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  label {
    font-size: $font-size-small;
    text-align: center;
    color: $sec5;
    font-weight: 500;
    margin-bottom: $spacing-small;
  }

  input[type=email] {
    width: 400px;
    height: 40px;
    box-sizing: border-box;
    border-radius: 0;
    border: 0;
    background: $sec7;
    padding: 8px;
    background-color: $sec7;
    color: $sec2;
  }

  input[type=email]:focus {
    outline: none !important;
    border:1px solid $blue;
  }

  button {
    margin-top: $spacing-base;
    background-color: $blue;
    color: #fff;
    border: 0;
    height: 40px;
    width: 250px;
    border-radius: $border-radius;
    font-weight: bold;
  }

  .description {
    color: $sec2;
    font-size: 18px;
    display: block;
    text-align: center;
    margin-bottom: $spacing-base*2;
    margin-top: $spacing-small;
  }
}

@media all and (min-width: 650px) {
  .rad-page {
    .about-header {
      display: block;
    }

    .about-header-mobile {
      display: none;
    }
  }
}

@media all and (max-width: 650px) {
  .rad-body {
    .doc-contents {
      display: block;
    }

    h1 {
      text-align: center;
      font-size: 36px;
    }

    span {
      text-align: center;
      display: block;
    }
  }
}
</style>